import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"
import { CurrencyHelper } from "~/helpers/currency_helper"

// This controller is used to delete the selected leads lists.
export default class extends Controller {
  static get targets() {
    return ["modal", "text"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      numberOfLeadsLists: { type: Number, default: 0 },
      selectedLeadsListIds: { type: Array, default: [] },
    }
  }

  connect() {
    if (this.hasTextTarget) {
      this.textTarget.innerText = i18n.t("js.back.leads_lists_actions.delete_lists", {
        count: this.numberOfLeadsListsValue,
        leads_lists: CurrencyHelper.numberWithDelimiter(this.numberOfLeadsListsValue),
      })
    }
  }

  // This action opens the modal to ask for confirmation before deleting the selected leads lists.
  show() {
    new bootstrap.Modal(this.modalTarget).show()
  }

  // This action submits a temporary form to delete the selected leads lists.
  submit(event) {
    event.target.disabled = true
    event.target.innerHTML = `<div class='far fa-spinner-third fa-spin'></div> ${i18n.t("js.back.leads_lists_actions.deleting")}`

    TempFormHelper.create("/leads-lists/bulk", "delete", (form) => {
      if (this.selectedLeadsListIdsValue.length > 0) {
        this.selectedLeadsListIdsValue.forEach((id) => {
          TempFormHelper.addHiddenInput(form, "leads_list_ids[]", id)
        })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, item)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    }).requestSubmit()
  }

  // This action is used to update the selected leads lists value and update the text in the modal based on the number
  // of leads lists.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadsListIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadsListIdsValue = event.detail.dataSets.map((dataSet) => dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadsListIdsValue = []
    }

    const numberOfLeadsLists = event.detail.checked > 0 ? event.detail.checked : this.numberOfLeadsListsValue

    if (this.hasTextTarget) {
      this.textTarget.innerText = i18n.t("js.back.leads_lists_actions.delete_lists", {
        count: numberOfLeadsLists,
        leads_lists: CurrencyHelper.numberWithDelimiter(numberOfLeadsLists),
      })
    }
  }
}
